import { ThemeEnum } from '@/shared/types/common.types';
import type { TModernColors } from '@modern/theme/modern-theme.types';
import type { TModernThemeMode } from '@modern/theme/theme-mode/theme-mode.types';
import { darkColors } from '@modern/theme/themes/colors/dark-theme';
import { lightColors } from '@modern/theme/themes/colors/light-theme';
import { sewDarkColors } from '@modern/theme/themes/colors/sew-dark-theme';
import { sewLightColors } from '@modern/theme/themes/colors/sew-light-theme';

type TModernPaletteSet = Readonly<Record<TModernThemeMode, TModernColors>>;

const SDA_PALETTES: TModernPaletteSet = {
  [ThemeEnum.DARK]: darkColors,
  [ThemeEnum.LIGHT]: lightColors,
};

export const MODERN_PALETTES: Readonly<Record<string, TModernPaletteSet>> = {
  sda: SDA_PALETTES,
  sew: {
    [ThemeEnum.DARK]: sewDarkColors,
    [ThemeEnum.LIGHT]: sewLightColors,
  },
};

export const getModernPalettes = (reseller?: string): TModernPaletteSet =>
  MODERN_PALETTES[reseller ?? ''] ?? SDA_PALETTES;
